import { render, staticRenderFns } from "./table-header-pagination.vue?vue&type=template&id=0e266027&scoped=true&"
import script from "./table-header-pagination.vue?vue&type=script&lang=ts&"
export * from "./table-header-pagination.vue?vue&type=script&lang=ts&"
import style0 from "./table-header-pagination.vue?vue&type=style&index=0&id=0e266027&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e266027",
  null
  
)

export default component.exports